module.exports = __webpack_public_path__ + "static/media/boiled-breakfast-egg-svgrepo-com.0d9d2073.svg";